// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ta-z","fullWidth":"Ua-z","heading":"Va-z","fullBleed":"Wa-z","hidden":"Xa-z"};